export const DataIcon = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect
      x='3.625'
      y='3.625'
      width='16.75'
      height='16.75'
      rx='2.375'
      fillOpacity='var(--nav-icon-fill-opacity, 0)'
      fill='currentColor'
      stroke='currentColor'
      strokeWidth='1.25'
      strokeLinecap='round'
    />
    <path
      d='M8 10V16'
      stroke='currentColor'
      strokeWidth='1.25'
      strokeLinecap='round'
    />
    <path
      d='M12 8L12 16'
      stroke='currentColor'
      strokeWidth='1.25'
      strokeLinecap='round'
    />
    <path
      d='M16 11L16 16'
      stroke='currentColor'
      strokeWidth='1.25'
      strokeLinecap='round'
    />
  </svg>
);
